import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'back-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss',
})
export class BackButtonComponent {
  public selectedTool: InputSignal<{ name: string; icon: string } | undefined> = input();
  public title: InputSignal<string | undefined> = input();

  public clearToolData: OutputEmitterRef<boolean> = output();

  public onClickBack(): void {
    console.log(this.selectedTool());
    if (this.selectedTool()) {
      this.clearToolData.emit(true);
      return;
    }

    window.location.href = `${environment.scattre.main}/car`;
  }
}
